import { render, staticRenderFns } from "./relationBind.vue?vue&type=template&id=71a9e610&scoped=true"
import script from "./relationBind.vue?vue&type=script&lang=js"
export * from "./relationBind.vue?vue&type=script&lang=js"
import style0 from "./relationBind.vue?vue&type=style&index=0&id=71a9e610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9e610",
  null
  
)

export default component.exports